import { SET_DATA } from './constants';
const temp = ['no_response', 'low_battery', 'is_active'];
export default {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    [SET_DATA](state, list) {
      state.data = list;
    }
  },
  actions: {
    load({ commit }) {
      const list = [];
      list.length = 3;
      list.fill({
        id: 1,
        device: 'Device ',
        date: new Date().toISOString(),
        status: 'no_response'
      });
      commit(
        SET_DATA,
        list.map((i, n) => {
          return {
            ...i,
            id: i.id + n,
            device: `${i.device} ${n}`,
            status: temp[n]
          };
        })
      );
    }
  }
};
